(() => {
  const prompts = [
    'Show me Yellowstone gifts.',
    'Help me find a gift under $50.',
    'Show me Big Sky whiskey glasses.',
    'Help me build a custom gift.',
    'What is new this week?',
    'Show me gifts for a cabin.',
    'Help me create a personalized keepsake.'
  ];

  document.querySelectorAll('.scout-dock-v2').forEach((dock) => {
    if (dock.dataset.ready === 'true') return;
    dock.dataset.ready = 'true';

    const trigger = dock.querySelector('.scout-dock-v2__trigger');
    const close = dock.querySelector('.scout-dock-v2__close');
    const promptButton = dock.querySelector('[data-scout-prompt]');
    const pageMessage = dock.querySelector('[data-scout-message]');
    const form = dock.querySelector('[data-scout-form]');
    const input = dock.querySelector('[data-scout-input]');
    const response = dock.querySelector('[data-scout-response]');
    const responseText = dock.querySelector('[data-scout-response-text]');

    let promptIndex = 0;

    function openDock() {
      dock.classList.add('is-open');
      trigger?.setAttribute('aria-expanded', 'true');
      window.setTimeout(() => input?.focus(), 250);
    }

    function closeDock() {
      dock.classList.remove('is-open');
      trigger?.setAttribute('aria-expanded', 'false');
    }

    function rotatePrompt() {
      promptIndex = (promptIndex + 1) % prompts.length;
      if (!promptButton) return;

      promptButton.animate(
        [
          { opacity: 1, transform: 'translateY(0)' },
          { opacity: 0, transform: 'translateY(-5px)' },
          { opacity: 0, transform: 'translateY(5px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ],
        { duration: 420, easing: 'ease' }
      );

      window.setTimeout(() => {
        promptButton.textContent = prompts[promptIndex];
      }, 200);
    }

    function setPageMessage() {
      if (!pageMessage) return;

      const pageType = dock.dataset.pageType || '';
      const productTitle = dock.dataset.productTitle || '';
      const collectionTitle = dock.dataset.collectionTitle || '';
      const cartCount = Number(dock.dataset.cartCount || 0);
      const cartTotal = Number(dock.dataset.cartTotal || 0);
      const threshold = Number(dock.dataset.freeShipping || 99);
      const path = window.location.pathname;

      if (pageType === 'product' && productTitle) {
        pageMessage.textContent =
          `Need help deciding on ${productTitle}? I can suggest matching products, gift ideas, or customization options.`;
        return;
      }

      if (pageType === 'collection' && collectionTitle) {
        pageMessage.textContent =
          `You are exploring ${collectionTitle}. Tell me who the gift is for and I will help narrow it down.`;
        return;
      }

      if (pageType === 'cart') {
        if (!cartCount) {
          pageMessage.textContent =
            'Your cart is empty. Tell me what you are shopping for and I will help you get started.';
          return;
        }

        const remaining = Math.max(0, threshold - cartTotal);

        if (remaining > 0) {
          pageMessage.textContent =
            `You have ${cartCount} item${cartCount === 1 ? '' : 's'} in your cart. You are about $${remaining.toFixed(0)} away from free shipping.`;
        } else {
          pageMessage.textContent =
            `You have ${cartCount} item${cartCount === 1 ? '' : 's'} in your cart and have reached the free-shipping threshold.`;
        }
        return;
      }

      if (pageType === 'search') {
        pageMessage.textContent =
          'Not finding it? Describe the destination, product, person, or budget and I will help refine the search.';
        return;
      }

      if (path.includes('/pages/resorts')) {
        pageMessage.textContent =
          'Need a custom resort or wholesale program? I can help you begin a collection or proposal.';
        return;
      }

      if (path.includes('/pages/events')) {
        pageMessage.textContent =
          'Planning a wedding, tournament, conference, or corporate event? Let us build the gift program.';
        return;
      }

      if (path.includes('/pages/contact')) {
        pageMessage.textContent =
          'Before you send a message, I may already know the answer. Ask me about products, customization, or timing.';
        return;
      }

      pageMessage.textContent =
        'Tell me what you are shopping for and I will help narrow it down.';
    }

    function escapeHtml(value) {
      return value.replace(/[&<>"']/g, (character) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      })[character]);
    }

    trigger?.addEventListener('click', openDock);
    close?.addEventListener('click', closeDock);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDock();
    });

    promptButton?.addEventListener('click', () => {
      if (!input) return;
      input.value = promptButton.textContent.trim();
      input.focus();
    });

    form?.addEventListener('submit', (event) => {
      event.preventDefault();

      const query = input?.value.trim();
      if (!query || !response || !responseText) return;

      response.hidden = false;
      responseText.textContent =
        'Scout is looking through Summit Line products...';

      const searchUrl =
        `/search?q=${encodeURIComponent(query)}&type=product`;

      window.setTimeout(() => {
        responseText.innerHTML =
          `I found results for “${escapeHtml(query)}.” <a href="${searchUrl}">View matching products →</a>`;
      }, 650);
    });

    setPageMessage();

    const timer = window.setInterval(rotatePrompt, 6000);

    document.addEventListener('shopify:section:unload', () => {
      window.clearInterval(timer);
    });
  });
})();
/* #11J.1 PRODUCT COLLISION GUARD */
(() => {
  const dock=document.querySelector('.scout-dock-v2[data-page-type="product"]');
  if(!dock||dock.dataset.commerceGuard==='true')return;
  dock.dataset.commerceGuard='true';
  const panel=dock.querySelector('.scout-dock-v2__panel');
  const trigger=dock.querySelector('.scout-dock-v2__trigger');
  const protectedSelectors=['.product__title','[id^="price-"]','.summit-style-selector','variant-selects','product-form','.product__description','.product__media-wrapper'];
  const intersects=(a,b)=>a&&b&&a.width>0&&a.height>0&&b.width>0&&b.height>0&&!(a.right<=b.left||a.left>=b.right||a.bottom<=b.top||a.top>=b.bottom);
  const enforce=()=>{
    if(innerWidth>=1200||!dock.classList.contains('is-open')||!panel)return;
    const panelRect=panel.getBoundingClientRect();
    const collision=protectedSelectors.some(selector=>[...document.querySelectorAll(selector)].some(node=>intersects(panelRect,node.getBoundingClientRect())));
    if(collision){dock.classList.remove('is-open');trigger?.setAttribute('aria-expanded','false');}
  };
  trigger?.addEventListener('click',()=>requestAnimationFrame(enforce));
  addEventListener('scroll',enforce,{passive:true});
  addEventListener('resize',enforce,{passive:true});
})();


/* Scout voice shopping + homepage rail position */
(() => {
  function updateHomepageRailPosition() {
    const dock = document.querySelector('.scout-dock-v2[data-page-type="index"]');
    const topSection = document.querySelector('#meet-scout');
    if (!dock || !topSection) return;
    const top = topSection.getBoundingClientRect().bottom + window.scrollY + 18;
    document.documentElement.style.setProperty('--scout-home-rail-top', `${Math.round(top)}px`);
  }

  function attachVoiceShopping(button) {
    const form = button.closest('form');
    const input = form?.querySelector('[data-scout-input]');
    const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!form || !input || !Recognition) {
      button.hidden = true;
      return;
    }
    button.addEventListener('click', () => {
      const recognition = new Recognition();
      recognition.lang = 'en-US';
      recognition.interimResults = false;
      recognition.maxAlternatives = 1;
      button.classList.add('is-listening');
      input.placeholder = 'Listening…';
      recognition.addEventListener('result', (event) => {
        const words = event.results[0][0].transcript.trim();
        if (!words) return;
        input.value = words;
        input.focus();
        window.setTimeout(() => form.requestSubmit(), 120);
      });
      recognition.addEventListener('end', () => button.classList.remove('is-listening'));
      recognition.addEventListener('error', () => {
        button.classList.remove('is-listening');
        input.placeholder = 'Try again or type your request';
      });
      recognition.start();
    });
  }

  document.querySelectorAll('[data-scout-voice]').forEach(attachVoiceShopping);
  updateHomepageRailPosition();
  addEventListener('resize', updateHomepageRailPosition, { passive: true });
  addEventListener('load', updateHomepageRailPosition, { once: true });
})();


(() => {
  const updateHomepageRail = () => {
    if (window.innerWidth < 1200) return;
    const rail = document.querySelector('.scout-dock-v2[data-page-type="index"]');
    const intro = document.querySelector('#meet-scout');
    if (!rail || !intro) return;
    const top = Math.max(112, Math.round(intro.getBoundingClientRect().bottom + 18));
    rail.style.setProperty('--scout-home-rail-viewport-top', top + 'px');
  };
  let queued = false;
  const requestUpdate = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; updateHomepageRail(); });
  };
  updateHomepageRail();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
})();
